module.exports = __webpack_public_path__ + "static/media/books.74d51d18.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/books.jpeg
// module id = 57
// module chunks = 17